import { createContext, useCallback, useContext, useMemo, useState } from "react";
import type { TimeGridEventData } from "@/features/dash/home/components/custom-time-grid-event";

export type CountsMap = Record<string, { current: number; max: number } | undefined>;

export const PlanningCountsContext = createContext<CountsMap | null>(null);
export const usePlanningCounts = () => useContext(PlanningCountsContext);

// Dérive la map des compteurs depuis les events et gère les overrides optimistes
type Jsonish = string | number | boolean | null | undefined | Jsonish[] | { [k: string]: Jsonish };
type LooseEvent = TimeGridEventData & { [key: string]: Jsonish };
export function usePlanningCountsSource(events: Array<TimeGridEventData | LooseEvent>) {
  const [optimisticCounts, setOptimisticCounts] = useState<Record<string, number>>({});

  const countsMap = useMemo(() => {
    const base: Record<string, { current: number; max: number }> = {};
    events.forEach((e) => {
      const current = typeof e.currentChildren === "number" ? e.currentChildren : 0;
      const max = typeof e.maxChildren === "number" ? e.maxChildren : 0;
      base[String(e.id)] = { current, max };
    });
    Object.entries(optimisticCounts).forEach(([id, c]) => {
      if (!base[id]) base[id] = { current: c, max: 0 };
      else base[id].current = c;
    });
    return base as CountsMap;
  }, [events, optimisticCounts]);

  const setOptimisticCount = useCallback((eventId: string, count: number) => {
    setOptimisticCounts((prev) => ({ ...prev, [eventId]: count }));
  }, []);

  return { countsMap, setOptimisticCount };
}
